import * as React from 'react';

import { ChatWindowInitial } from '../../components/ChatWindowInitial';
import { useRuntimeSetting } from '../../hooks/useRuntimeSetting';

export const ChatWindowInitialContainer = () => {
  const backgroundImageUrl = useRuntimeSetting<string>('frontend-chats.backgroundImage', '');

  return <ChatWindowInitial backgroundImageUrl={backgroundImageUrl} />;
};
